import Events from "./Components/Core/Events";
import Forms from "./Components/Forms/forms";
import {favoritesInit, favoritesInitItem} from "./Components/Favorites/favorites";
import {compareInit, compareInitItem} from "./Components/Compare/compare";
import Locations from './Components/Locations/locations';
import {cartInfoInit} from "./Components/basket/updateCartInfo";
import MmenuLight from "mmenu-light";
import Agent from "./Components/Core/agent";
import {searchAutocomplete} from "./Components/Search/search";
import {modal} from "./Components/UI/modal";
import {notice} from "./Components/UI/notice";
import {empty} from "./Components/Core/common";
import AuthApi from "./Components/Api/AuthApi";

const events = new Events();

cartInfoInit(events);

const form = new Forms(events);
let locations = new Locations(events);


document.querySelectorAll('.geo_location').forEach(item => item.addEventListener('click', () => {
    locations.getLocations(item);
}));

favoritesInit('.js_add_favorites', events);
compareInit('.js_add_compare', events);

if (document.querySelector('input[type="tel"]')) {
    let phoneFormatter = async () => await import('./Components/phone');
    phoneFormatter().then(e => e.init());
}

let initBasket;
if (document.querySelector('.js_add_to_cart')) {
    if (!initBasket) {
        initBasket = async () => await import("./Components/basket/basket");
    }

    initBasket()
        .then(f => f.initBasketEvents('.js_add_to_cart', events));
}

document.querySelectorAll('.spoiler').forEach(item => {
    let btn = item.querySelector('.spoiler-btn');
    if (btn) {
        btn.addEventListener('click', function (event) {
            event.preventDefault();
            if (!item.classList.contains('active')) {
                item.classList.add('active');
            } else {
                item.classList.remove('active');
            }
        });
    }
});

document.querySelectorAll('.js-filter__hidden').forEach(item => {
    let btn = item.querySelector('.js-filter__hidden-btn');
    if (btn) {
        btn.addEventListener('click', () => {
            if (!item.classList.contains('active')) {
                item.classList.add('active');
            } else {
                item.classList.remove('active');
            }
        });
    }
});

function spoilerPiece(spoiler, height) {
    document.querySelectorAll(spoiler).forEach(categoryTags => {
        const items = categoryTags.querySelector('.spoiler-items');
        const block = categoryTags.querySelector('.spoiler-block');
        if (items) {
            if (items.clientHeight <= height) {
                let btn = categoryTags.querySelector('.spoiler-btn');
                if (btn) {
                    btn.style.display = 'none';
                    block.style.height = 'auto';
                    block.style.minHeight = 'unset';
                }
            } else {
                categoryTags.querySelector('.spoiler-btn').style.display = 'flex';
            }
        }
    });
}

spoilerPiece('.tags-spoiler', 120);

let reInitBasket;
events.addListener('filter.search', null, () => {
    document.querySelectorAll('.js_add_favorites').forEach(item => favoritesInitItem(item));
    document.querySelectorAll('.js_add_compare').forEach(item => compareInitItem(item));
    if (!reInitBasket) {
        if (!initBasket) {
            initBasket = async () => await import("./Components/basket/basket");
        }

        initBasket().then(f => {
            reInitBasket = f.reInitBasketEvents;
            reInitBasket('.js_add_to_cart', events);
        });
    } else {
        reInitBasket('.js_add_to_cart', events);
    }


    form.initModalForm(document);

    document.querySelectorAll('.product-item').forEach(item => {
        if (!item.classList.contains('btn-char-initialized')) {
            item.classList.add('btn-char-initialized');
            let btn_char = item.querySelector('.btn-char');
            if (btn_char) {
                btn_char.addEventListener('click', () => {
                    item.querySelector('.flip-container').classList.toggle('active');
                });
            }
            let flip_close = item.querySelector('.flip-close');
            if (flip_close) {
                flip_close.addEventListener('click', () => {
                    item.querySelector('.flip-container').classList.remove('active');
                });
            }
        }
    });
});

if (document.querySelector('.js_filter_form')) {
    const filter = async () => await import("./Components/Filter/filter");
    filter().then(f => f.init(events));
}

const mobileMenuElement = document.querySelector("#mobile-menu");
const mobileMenuItemsElements = document.querySelectorAll('a[href="#mobile-menu"]');
if (mobileMenuElement && mobileMenuItemsElements) {
    let mobileMenu = new MmenuLight(mobileMenuElement);
    let closeMenu = mobileMenu.menu.querySelector('.mobile-menu__close');
    mobileMenu.navigation({
        title: "Меню",
        theme: "dark"
    });
    let drawerMenu = mobileMenu.offcanvas();
    mobileMenuItemsElements.forEach(mmenu => {
        mmenu.addEventListener('click',  event=> {
            event.preventDefault();
            drawerMenu.open();
        });
    });
    closeMenu.addEventListener('click', () => {
        drawerMenu.close();
    });
}

if (document.querySelector('.scroll-item')) {
    document.addEventListener('scroll', () => {
        if (window.pageYOffset > 300) {
            document.querySelectorAll('.scroll-item').forEach(item => {
                item.classList.add('active');
            });
        } else {
            document.querySelectorAll('.scroll-item').forEach(item => {
                item.classList.remove('active');
            });
        }
    });
    document.querySelector('.scroll-item').addEventListener('click', () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    });
}

if (document.querySelector('.category-filter')) {
    let btn = document.querySelector('.btn-filter');
    let filter = document.querySelector('.category-filter');
    if (btn) {
        document.addEventListener('click', (e) => {
            if (filter.classList.contains('active')) {
                if (e.target === filter) {
                    filter.classList.remove('active');
                }
            }
        });
        btn.addEventListener('click', () => {
            filter.classList.add('active');
        });
    }
}

const loadViewed = document.querySelector('.viewed');
if (loadViewed) {
    let observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                if (!loadViewed.querySelector('div')) {
                    Agent.post(`/api/v1/viewed`)
                        .then(e => e.json())
                        .then(e => {
                            if (e.success) {
                                loadViewed.innerHTML = e.data;
                                events.dispatch('filter.search');
                            }
                        })
                        .catch(e => console.log(e))
                        .finally(() => {
                            obs.unobserve(entry.target);
                        });
                }
            }
        });
    });

    observer.observe(loadViewed);
}

if (document.querySelector('.js_search')) {
   // searchAutocomplete.init();
}

document.querySelectorAll('.js_open_autorize_form').forEach(item => item.addEventListener('click', () => {
    const options = {
        message: `<div class="modalc-main d-flex flex-column">
                    <div class="modalc-header d-flex flex-column">
                        <h2 class="fw-sb fs-28">Вход в кабинет пациента</h2>
                        <p>Укажите номер телефона, мы отправим на него СМС код для входа</p>
                    </div>
                    <form class="modalc-form appointment-form d-flex flex-column" name='authorization' method='post' autocomplete="off">
                        <label class="input-block d-flex">
                            <span class="input-block__title d-flex align-items-start justify-content-between py-15">
                                <span class="fw-md">Номер телефона</span>
                                <i class="icon fs-18 arrow_forward"></i>
                            </span>
                            <span class="light-input input-block__input">
                            <input class="w-100 rounded-pill px-25 py-15" type="tel" name="phone"
                             placeholder="+7 (9__) ___-__-__" required></span>
                        </label>
                        <div class="input-block d-flex">
                            <span
                                class="input-block__title d-flex align-items-start justify-content-between py-15"><span
                                class="fw-md">Отправим СМС код</span>
                                <i class="icon fs-18 arrow_forward"></i>
                            </span>
                            <span class="light-input input-block__input">
                                <button class="btn btn-main w-100 js_recover_password">
                                    Получить СМС-код
                                </button>
                            </span>
                        </div>
                        <div class="message w-100 d-flex justify-content-center">
                            <span class="fw-regular fs-14 text-danger js_message_label"></span>
                            <span class="fw-regular fs-14 text-danger js_message_sms_label d-none"> </span>
                        </div>
                    </form>
                </div>`,
        showEvent: function (to) {

            let inputPhone = to.querySelector('input[name="phone"]');
            let js_recover_password = to.querySelector('.js_recover_password');
            let js_message_label = to.querySelector('.js_message_label');
            let js_message_sms_label = to.querySelector('.js_message_sms_label');
            let form = to.querySelector('form');

            const authorization = (userName, password) => {
                js_message_label.innerHTML = '';

                if (empty(userName) || empty(password)) {
                    notice("Необходимо заполнить<br> обязательные поля.");
                    return;
                }

                AuthApi.authorization(userName, password)
                    .then(response => response.json())
                    .then(response => {
                        if (response.success) {
                            if (response.url) {
                                document.location.href = response.url;
                            } else {
                                document.location.reload();
                            }
                        } else {
                            notice(response.message);
                        }
                    })
                    .catch(() => {
                        notice("Не удалось сменить пароль.<br> Попробуйте позже <br>или<br> обратитесь к администратору.");
                    });
            };

            const timer = (timerPeriod, start, tick, finish) => {
                let counter = timerPeriod || 1;
                if (typeof start === 'function') {
                    start();
                }
                if (typeof tick === 'function') {
                    tick(counter);
                }
                let smsTimer = setInterval(function () {
                    counter--;
                    if (typeof tick === 'function') {
                        tick(counter);
                    }
                    if (counter === 0) {
                        counter = timerPeriod;
                        clearInterval(smsTimer);
                        if (typeof finish === 'function') {
                            finish();
                        }
                    }
                }, 1000);
            };

            const smsTimer = seconds => {
                timer(parseInt(seconds), function () {
                    js_recover_password.disabled = true;
                    js_message_sms_label.classList.remove('d-none');
                }, function (secondsLeft) {
                    js_message_sms_label.innerHTML = `Пароль был выслан на указанный номер. <br>Следующая отправка СМС возможна через <b>${secondsLeft}</b> секунд`;
                }, function () {
                    js_recover_password.disabled = false;
                    js_message_sms_label.classList.add('d-none');
                });
            };

            const recover_password = function () {

                let phone = inputPhone.value;
                if (empty(phone)) {
                    notice("Необходимо заполнить<br> обязательные поля.");
                } else {
                    js_recover_password.classList.add('preloader');
                    AuthApi.recoverPassword(phone)
                        .then(response => response.json())
                        .then(response => {
                            if (response.success) {
                                const authDialog = `
                                <div class="modalc-main d-flex flex-column">
                                            <div class="modalc-header d-flex flex-column">
                                                <h2 class="fw-sb fs-28">Вход в кабинет пациента</h2>
                                                <p>Укажите номер телефона, мы отправим на него СМС код для входа</p>
                                                <button class="btn btn-inline d-flex gap-10 js_form_reset" type="button">
                                                    <i class="icon fs-18 arrow_forward rotate_180"></i>
                                                <span class="fw-md">Изменить номер телефона</span>
                                                </button>
                                                <button class="btn btn-inline d-flex gap-10 js_form_reset" type="button">
                                                    <i class="icon fs-18 refresh"></i>
                                                    <span class="fw-md">
                                                        Отправить код снова <span class="o-0_6"></span>
                                                    </span>
                                                </button>
                                            </div>
                                            <form class="modalc-form appointment-form d-flex flex-column" name="modal-registration"
                                                  autocomplete="off">
                                                <label class="input-block d-flex">
                                                    <span class="input-block__title d-flex align-items-start justify-content-between py-15">
                                                    <span class="fw-md">4 цифры СМС кода</span>
                                                        <i class="icon fs-18 arrow_forward"></i>
                                                    </span>
                                                    <span class="light-input input-block__input">
                                                        <input class="w-100 rounded-pill px-25 py-15" type="password" name="sms-code" placeholder="_ _ _ _" required>
                                                    </span>
                                               </label>
                                                <div class="input-block d-flex">
                                                    <span class="input-block__title d-flex align-items-start justify-content-between py-15">
                                                    <span class="fw-md">Войти</span>
                                                        <i class="icon fs-18 arrow_forward"></i>
                                                    </span>
                                                    <span class="light-input input-block__input">
                                                        <button class="btn btn-main w-100 js_auth_button" type="button">Войти в личный кабинет</button>
                                                    </span>
                                                </div>
                                                <div class="modalc-form__error d-flex align-items-center rounded-15 d-none">
                                                    <i  class="icon fs-24 error text-main"></i> <span class="fw-md">СМС-код неверный</span>
                                                </div>
                                            </form>
                                        </div>`;
                                const showEventForAuthDialog = (to) => {
                                    let setValue = to.querySelector(['[name="sms-code"]']);
                                    to.querySelectorAll('.js_form_reset').forEach(codeItem => {
                                        codeItem.addEventListener('click', () => item.dispatchEvent(new Event('click')));
                                    });

                                    let js_auth_button = to.querySelector('.js_auth_button');
                                    js_auth_button.addEventListener('click', () => {
                                        if (setValue.value.trim().length > 3) {
                                            authorization(phone, setValue.value);
                                        }
                                    });
                                };
                                modal(authDialog, showEventForAuthDialog);

                            } else {
                                if (response.message && !response.seconds) {
                                    js_message_label.innerHTML = response.message;
                                }
                                if (response.seconds) {
                                    smsTimer(response.seconds);
                                }
                            }

                        })
                        .catch(() => {
                            notice("Не удалось отправить пароль.<br> Попробуйте позже<br> или<br> обратитесь к администратору.");
                        })
                        .finally(() => {
                            js_recover_password.classList.remove('preloader');
                        });
                }
            };


            inputPhone.addEventListener('input', () => {
                js_message_label.innerHTML = '';
            });


            js_recover_password.addEventListener('click', () => {
                js_message_label.innerHTML = '';
                recover_password();
            });

            form.addEventListener('submit', event => {
                event.stopPropagation();
                event.preventDefault();
            });
        }
    };

    modal(options);
}));

document.querySelectorAll('.js-city').forEach(item => {
    let cities = item.querySelector('.js-city__all');
    let active = item.querySelector('.js-city__active');
    active.addEventListener('mouseover', () => {
        cities.classList.add('active');
    });
    item.addEventListener('mouseleave', () => {
        cities.classList.remove('active');
    });
});

import StarRating from 'star-rating.js';
import Choices from "choices.js";
import SearchApi from "./Components/Api/search-api";

document.querySelectorAll('.star-rating').forEach(item => {
    new StarRating(item, {
        clearable: true,
        tooltip: false,
        maxStars: 5,
    });
});

document.querySelectorAll('.js-callMenu').forEach(item => {
    let btn = document.querySelector('.js-callMenu__btn');
    btn.addEventListener('click', () => {
        item.classList.toggle('active');
    });
});

document.querySelectorAll('.js-msearch').forEach(search => {
    let body = document.querySelector('body');
    let openBtn = document.querySelector('.js-msearch__open');
    let closeBtn = search.querySelector('.js-msearch__close');
    let input = search.querySelector('.js-msearch__input');
    let inputBtn = search.querySelector('.js-msearch__btn');
    let inputRemove = search.querySelector('.js-msearch__remove');
    openBtn.addEventListener('click', () => {
        body.classList.toggle('search-open');
        search.classList.toggle('active');
        input.focus();
    });
    closeBtn.addEventListener('click', () => {
        body.classList.remove('search-open');
        search.classList.remove('active');

        inputRemove.dispatchEvent(new Event('click'));

    });
    inputRemove.addEventListener('click', () => {
        inputBtn.classList.remove('d-none');
        inputRemove.classList.remove('d-flex');
    });

    input.addEventListener('input', () => {
        if (input.value) {
            inputBtn.classList.add('d-none');
            inputRemove.classList.add('d-flex');
        } else {
            inputBtn.classList.remove('d-none');
            inputRemove.classList.remove('d-flex');
        }
    });

});

(function () {
    function setHeight() {
        var vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    }

    setHeight();
    window.addEventListener('resize', setHeight);
})();


const dropdownList = new WeakSet();
function initDropdowns() {
    document.querySelectorAll('.dropdawn').forEach(item => {
        if(dropdownList.has(item) === false){
            dropdownList.add(item);
            item.addEventListener("mouseover", function() {
                item.querySelector('.dropdawn-btn').classList.add('active');
                item.querySelector('.dropdawn-menu').classList.add('active');
            });

            item.addEventListener("mouseleave", function() {
                const timer = setTimeout(function() {
                    item.querySelector('.dropdawn-btn').classList.remove('active');
                    item.querySelector('.dropdawn-menu').classList.remove('active');
                }, 300);

                const cancelLeave = function() {
                    clearTimeout(timer);
                    item.querySelector('.dropdawn-btn').classList.add('active');
                    item.querySelector('.dropdawn-menu').classList.add('active');
                    item.removeEventListener('mouseover', cancelLeave);
                };

                item.addEventListener('mouseover', cancelLeave);
            });

        }
    });
}

initDropdowns();

class ResponsiveNavigation {
    constructor(options = {}) {
        this.navContainer = options.navContainer;
        this.navItems = options.navItems || Array.from(this.navContainer.children);
        this.dropdownSelector = options.dropdownSelector || 'dropdawn';
        this.dropdownBtnSelector = options.dropdownBtnSelector || 'dropdawn-btn';
        this.dropdownMenuSelector = options.dropdownMenuSelector || 'dropdawn-menu';
        this.dropdownMenuWrapperSelector = options.dropdownMenuWrapperSelector || 'dropdawn-menu__wrapper';
        this.dropdownMenuItemsSelector = options.dropdownMenuItemsSelector || 'dropdawn-menu__items';
        this.moreText = options.moreText || 'Ещё';
        this.checkInterval = options.checkInterval || 200;
        this.dropdawnCatalogHref = options.catalogHref || 'catalog.html';
        this.dropdawnCatalogSelector = options.catalogSelector || 'dropdawn-menu__catalog btn-neutral d-flex align-items-center justify-content-between';
        this.dropdown = null;
        this.dropdownBtn = null;
        this.dropdownMenu = null;
        this.hiddenItems = [];
        this.dropdownHoverTimer = null;
        this.init();
    }

    init() {
        this.createDropdown();
        this.checkNavigation();
        this.setupResizeListener();
    }

    createDropdown() {
        this.dropdown = document.createElement('div');
        this.dropdown.className = this.dropdownSelector;
        this.dropdownBtn = document.createElement('button');
        this.dropdownBtn.className = this.dropdownBtnSelector;
        let dropdawnText = document.createElement('span');
        dropdawnText.textContent = this.moreText;
        let chevron = document.createElement('i');
        chevron.classList.add('icon', 'fs-16', 'chevron');
        this.dropdownBtn.appendChild(dropdawnText);
        this.dropdownBtn.appendChild(chevron);
        this.dropdownMenu = document.createElement('div');
        this.dropdownMenu.className = this.dropdownMenuSelector;
        this.dropdownMenuWrapper = document.createElement('div');
        this.dropdownMenuWrapper.classList = this.dropdownMenuWrapperSelector;
        this.dropdownMenuItems = document.createElement('div');
        this.dropdownMenuItems.classList = this.dropdownMenuItemsSelector;
        this.dropdawnCatalog = document.createElement('a');
        this.dropdawnCatalog.textContent = 'В каталог';
        this.dropdawnCatalog.setAttribute('href', this.dropdawnCatalogHref);
        this.dropdawnCatalog.classList = this.dropdawnCatalogSelector;
        let arrow = document.createElement('i');
        arrow.classList.add('icon', 'fs-18', 'arrow');
        this.dropdawnCatalog.appendChild(arrow);
        this.dropdown.appendChild(this.dropdownBtn);
        this.dropdown.appendChild(this.dropdownMenu);
        this.dropdownMenu.appendChild(this.dropdownMenuWrapper);
        this.dropdownMenuWrapper.appendChild(this.dropdownMenuItems);
        this.dropdownMenuWrapper.appendChild(this.dropdawnCatalog);
        this.navContainer.appendChild(this.dropdown);
        // this.navItems.push(this.dropdown);
        this.dropdown.style.display = 'none';
        initDropdowns();
    }

    checkNavigation() {
        const containerWidth = this.navContainer.offsetWidth;
        let totalWidth = 0;
        const visibleItems = [];
        this.hiddenItems = [];

        this.navItems.forEach(item => {
            if (item !== this.dropdown) {
                item.style.display = '';
            }
        });
        this.dropdown.style.display = 'none';

        let canFitMore = true;
        this.navItems.forEach((item, index) => {
            if (item === this.dropdown || !canFitMore) {
                if (item !== this.dropdown){
                    this.hiddenItems.push(item);
                }
                return;
            }

            const itemWidth = item.offsetWidth + this.getItemMargin(item);

            if (totalWidth + itemWidth <= containerWidth) {
                totalWidth += itemWidth;
                visibleItems.push(item);
            } else {
                canFitMore = false;
                this.hiddenItems.push(item);
                for (let i = index + 1; i < this.navItems.length; i++) {
                    if (this.navItems[i] !== this.dropdown) {
                        this.hiddenItems.push(this.navItems[i]);
                    }
                }
            }
        });

        if (this.hiddenItems.length > 0) {
            this.dropdown.style.display = '';
            const dropdownWidth = this.dropdown.offsetWidth + this.getItemMargin(this.dropdown);

            while (visibleItems.length > 0 && totalWidth + dropdownWidth > containerWidth) {
                const removedItem = visibleItems.pop();
                this.hiddenItems.unshift(removedItem);
                totalWidth -= (removedItem.offsetWidth + this.getItemMargin(removedItem));
            }

            this.navItems.forEach(item => {
                if (item !== this.dropdown) {
                    item.style.display = visibleItems.includes(item) ? '' : 'none';
                }
            });

            this.updateDropdownContent();
            this.dropdown.style.display = '';
        } else {
            this.dropdown.style.display = 'none';
        }
    }

    getItemMargin(item) {
        const style = window.getComputedStyle(item);
        const marginLeft = parseFloat(style.marginLeft) || 0;
        const marginRight = parseFloat(style.marginRight) || 0;
        return marginLeft + marginRight;
    }

    updateDropdownContent() {
        this.dropdownMenuItems.innerHTML = '';

        this.hiddenItems.forEach(item => {
            const dropdownItem = item.cloneNode(true);
            dropdownItem.style.display = '';
            dropdownItem.style.visibility = 'visible';
            dropdownItem.className = 'dropdown-menu-item fw-bl href-main';
            dropdownItem.addEventListener('click', () => {
                this.hideDropdownMenu();
            });
            this.dropdownMenuItems.appendChild(dropdownItem);
        });
    }

    hideDropdownMenu() {
        this.dropdownBtn.classList.remove('active');
        this.dropdownMenu.classList.remove('active');
        if (this.dropdownHoverTimer) {
            clearTimeout(this.dropdownHoverTimer);
        }
    }

    setupResizeListener() {
        let resizeTimeout;
        const handleResize = () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                this.checkNavigation();
            }, this.checkInterval);
        };
        window.addEventListener('resize', handleResize);
        this.handleResize = handleResize;
    }

    refresh() {
        this.checkNavigation();
    }
}

const nav = document.querySelector('.js-header_catalog');
new ResponsiveNavigation({
    navContainer: nav,
    navItems: nav.querySelector('.header-catalog__wrapper').querySelectorAll('.js_header_catalog_item'),
    moreText: 'Ещё',
    dropdownBtnSelector: 'dropdawn-btn d-flex align-items-end',
    dropdownSelector: 'dropdawn header-catalog__dropdawn position-relative',
    catalogHref: '/catalog/'
});



document.querySelectorAll("[data-id='section-filter']").forEach(filter => {
    let city = filter.querySelector("#city");
    let cityChoice = null;
    if (city) {
        cityChoice = new Choices(city, {
            itemSelectText: '',
            position: 'bottom',
            searchEnabled: false,
        });
    }


    filter.querySelectorAll('[name="heat_region"]').forEach(item => item.addEventListener('change', () => {

        Agent.post(`/api/v1/heat/city/${item.value}`)
            .then(e => e.json())
            .then(e => {
                if (e.success) {
                    if (city) {
                        cityChoice.clearChoices();
                        cityChoice.clearInput();
                        cityChoice.setChoices([...e.data.map(item => {
                            return {'value': item.id, 'label': item.name};
                        })]);
                        city.dispatchEvent(new Event('change'));
                    }
                } else {
                    notice(e.message);
                }
            })
            .catch(e => console.log(e));
    }));

    filter.querySelectorAll("[name='is_building_basement']")
        .forEach(item => item.addEventListener('change', () => {
            filter.querySelector("[name='building_basement']").disabled = (+item.value === 0);
        }));

    filter.querySelectorAll("#btn-heat").forEach(item => item.addEventListener('click', () => {
        item.classList.add('preloader');
        item.disabled = true;

        const formData = new FormData();
        formData.append('city', city.value);
        formData.append('v', filter.querySelector("#V").value);
        formData.append('type_of_fuel', filter.querySelector("[name='fuel']").value);
        formData.append('construction', filter.querySelector('[name="construction"]').value);
        formData.append('type', item.dataset.id || 1);

        formData.append('building_basement', filter.querySelector("[name='building_basement']").value);


        let js_power_calculation_result = filter.querySelector('.js_power_calculation_result');
        js_power_calculation_result.innerHTML = '';

        Agent.post(`/api/v1/heat/find/`, formData)
            .then(e => e.json())
            .then(e => {
                if (e.success) {
                    filter.querySelector('.js_power_calculation_result_power').innerHTML = `<p><strong>Вам подойдут котлы мощностью ${e.qmax.power_kvt} кВт / ${e.qmax.power_ggal} Гкал / ${e.qmax.power_mvt} МВт</strong></p>`;
                    if (e.count) {
                        js_power_calculation_result.innerHTML = `${e.data}`;
                    } else {
                        js_power_calculation_result.innerHTML = `<div class="choosing-result__wrapper d-flex flex-column gap-20">${e.data}</div>`;
                    }

                    events.dispatch('filter.search');
                } else {
                    notice(e.message);
                }
            })
            .catch(e => console.log(e))
            .finally(() => {
                item.classList.remove('preloader');
                item.disabled = false;
            });
    }));
});

document.querySelectorAll('.js_search').forEach(search => {
    let wrapper = search.querySelector('.js_search-wrapper');
    let input = search.querySelector('input');
    let result = search.querySelector('.search-result');
    let resultValue =  result.querySelector('.search-result__value');
    let closeBtn = search.querySelector('.search-close');
    let hints = search.querySelectorAll('.js_search-hint');
    let timers = null;

    const itemDesktopTemplate = (item, price) => {
        let disabledBtn = '';
        if(price < 1){
            disabledBtn = 'disabled';
        }
      return  `<div class="product-item d-flex overflow-hidden position-relative js_item" data-id="${item.id}">
    <a class="product-item__img js_swipeHover" href="${item.url}" title="${item.title}">
        <img src="${item.img}" title="">
    </a>
    <div class="product-item__desc d-flex flex-grow-1">
        <div class="product-item__info d-flex flex-grow-1">
            <div class="product-item__heading d-flex flex-column align-items-start">
                <div class="product-item__tags d-flex flex-wrap">
                </div>
                <a class="href-main product-item__title fw-bl" href="${item.url}">${item.title}</a>
            </div>
            <div class="product-item__tools d-flex flex-column">
                
            </div>
        </div>
        <div class="product-item__buy d-grid">
            <div class="product-item__price d-flex flex-column">
                <span class="fs-xl-15 fs-12 text-second">Цена:</span>
                <span class="fw-bl product-item__price-current">${item.price}</span>
            </div>
            <div class="product-item__btns">
                <button class="product-item__cart d-flex rounded-circle js_add_to_cart js_product_search" 
                aria-label="Добавить товар в корзину" disabledBtn title="Добавить товар в корзину"
                  data-product_id="${item.id}"
                  data-id="${item.id}"
                >
                    <i class="icon fs-24 add_cart" aria-hidden="true"></i>
                </button>
            </div>
        </div>
    </div>
</div>`;
    }
    const buildResultForDesktop = items => {
        let message = `<a class="d-flex justify-content-between gap-10">По вашему запросу ничего не найдено</a>`;
        if (items.length) {
            message = '';
            let categories = [];
            let products = [];
            items.forEach(category => {
                categories.push(`<a class="header-search__category href-main d-flex align-items-center rounded-8 bg-second_bg" href="${category.url}">
                        <div class="header-search__category-img">
                            <img src="${category.img}" alt="${category.title}" loading="lazy">
                        </div>
                        <span class="fw-bl">${category.title}</span>
                    </a>`);

                category.childs.forEach(item => {
                    item.price = item.price > 0 ? item.price += ' ₽' : 'Цена по запросу';
                    products.push(itemDesktopTemplate(item, item.price));
                });

            });

            if(categories.length){
                message += `<div class="header-search__suggests d-flex flex-column scroll scroll-visible scroll-visible_sm"><div class="header-search__categories d-flex flex-column">${categories.join('')}</div></div>`;
            }

            if(products.length){
                events.dispatch('filter.search');
                message += `<div class="header-search__products"><span class="fs-20 fw-bl">Результаты поиска </span><div class="header-search__products-grid scroll scroll-visible scroll-visible_sm">${products.join('')}</div></div>`;
            }

        }
        message += "</div>";
        return message;
    };

    const searchData = (searchPhrase) => {
        resultValue.classList.add('preloader');
        resultValue.innerHTML = '';
        SearchApi.autocomplete(searchPhrase)
            .then(e => e.json())
            .then(e => {
                if (e.success) {
                    resultValue.innerHTML = buildResultForDesktop(e.data);
                }
            })
            .finally(() => resultValue.classList.remove('preloader'));

    };


    input.addEventListener('input', () => {
        clearTimeout(timers);
        if(input.value.trim().length > 1){
            resultValue?.classList.add('active');
            closeBtn?.classList.add('active');
            timers = setTimeout(searchData.bind(null, input.value.trim()), 500);
        } else {
            resultValue?.classList.remove('active');
            closeBtn?.classList.remove('active');
        }
    });
    hints?.forEach(hint => {
        hint.addEventListener('click', () => {
            input.value = hint.innerHTML;
            input.dispatchEvent(new Event('input'));
            resultValue?.classList.add('active');
            closeBtn?.classList.add('active');
        });
    });
    input.addEventListener('click', () => {
        input.classList.add('active');
        result?.classList.add('active');
        if(input.value.trim().length > 1){
            resultValue?.classList.add('active');
            closeBtn?.classList.add('active');
        }
    });
    closeBtn?.addEventListener('click', function(){
        if(closeBtn.classList.contains('active')){
            resultValue?.classList.remove('active');
            closeBtn?.classList.remove('active');
            input.value = '';
        }
    });
    document.addEventListener('click', function(e){
        if(!e.target.closest('.js_search-wrapper')){
            resultValue?.classList.remove('active');
            result?.classList.remove('active');
            input.classList.remove('active');
            closeBtn?.classList.remove('active');
        }
    });
});
export default events;